module.exports = __webpack_public_path__ + "img/pic7.b4fa98fa.png";